import React,{useEffect, useRef} from 'react'
import AccountLayout from '../../../../../layout/components/AccountLayout'
import { useState } from 'react'
import TransactionForm from '../components/TransactionForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import transactionServices from '../transactionServices';
import { useAlert } from '../../../../../context/AlertContext';



const CellActions = (props) =>{
    return(
        <>
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function TransactionListPage() {

  
  const {companyDD, getDDDataById, transactionList,getTransactionList,getMasterLabel} = useAppData();
  const gridRef = useRef();
  const {AppAlert} = useAlert();
  

  const remove = (id) =>{
    console.log("I will remove transaction number",id)
    transactionServices.remove(id).then(res=>{
      AppAlert(res.msg,)
    }).catch(error=>{
      AppAlert(error.msg,"error")
    })
  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        
        {headerName: "Company", width:300,
          valueGetter:params=>{
            return getDDDataById(companyDD,params.data.companyId).label;
          }
        }, 
        
        {field:"transactionAmount",headerName: "Transaction Amount",width:250},
        {field:"transactionDate",headerName: "T. Date"},
        {headerName: "Method",
          valueGetter:params=>{
            return getMasterLabel("transaction-method",params.data.transactionMethod);
          }
        },
        {field:"transactionNo",headerName: "Transaction #",width:150},
        
        
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getTransactionList,
                remove:remove
            },
        },
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <AccountLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Transaction</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><TransactionForm callBack={getTransactionList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={transactionList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getTransactionList}
              />
            </div>
          </div>
        </div>
    </AccountLayout>
    
  )
}

export default TransactionListPage